/* eslint-disable no-underscore-dangle */
export const buildPageData = (pages) => {
  if (pages?.length) {
    return pages.map((page) => ({
      id: page.id,
      type: page.type,
      title: page.title,
      space: page.space.name,
      link: `${window.AP._hostOrigin}/wiki${
        page._links.tinyui || page._links.webui
      }`,
    }));
  }
  return [];
};

export const buildAttachmentData = (attachments) => {
  if (attachments.length) {
    return attachments.map((att) => ({
      title: att.title,
      type: att.metadata.mediaType,
      id: att.id,
      link: `${window.AP._hostOrigin}/wiki${att._links.webui}`,
      spaceKey: att.space.key,
      space: att.space.name,
    }));
  }
  return [];
};
